import React, { useCallback } from 'react';
import { FieldArrayContext } from '../../../../../../@common/field-array-context';
import { InsertPosition } from '../../../../../../@common/types';
var Item = React.memo(function (_a) {
    var add = _a.add, cb = _a.cb, fieldName = _a.fieldName, remove = _a.remove, name = _a.name, index = _a.index;
    var removeHandler = useCallback(function () {
        remove(index);
    }, [index, remove]);
    var append = useCallback(function (initialValue) {
        add(initialValue, index, InsertPosition.AFTER);
    }, [add, index]);
    var prepend = useCallback(function (initialValue) {
        add(initialValue, index, InsertPosition.BEFORE);
    }, [add, fieldName, index]);
    return (React.createElement(FieldArrayContext.Provider, { key: name, value: { name: name } }, cb({
        append: append,
        key: name,
        prepend: prepend,
        remove: removeHandler,
    }, index)));
});
export var map = function (add, remove, list, fieldName, callback) {
    return list.map(function (index) {
        var name = fieldName + "." + index;
        return (React.createElement(Item, { key: name, add: add, cb: callback, remove: remove, name: name, fieldName: fieldName, index: index }));
    });
};
